// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3wQI5","selected":"Chip_selected__16paC"};